export default function getExtent(feature) {
    const geometry = feature.getGeometry();
    if (!geometry) {
        return null;
    }
    return geometry.getExtent();
}
